var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-popover',_vm._b({attrs:{"top":_vm.top,"offset-y":_vm.offsetY},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-icon',_vm._g({class:_vm.iconClasses,attrs:{"size":_vm.iconSize}},on),[_vm._v("\n\t\t\t"+_vm._s(_vm.iconName)+"\n\t\t")])]}}])},'base-popover',_vm.$attrs,false),[_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }